import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b38e340"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "send-test-email-dialog__layout" };
const _hoisted_2 = { class: "send-test-email-dialog__content" };
const _hoisted_3 = { class: "send-test-email-dialog__title-row" };
const _hoisted_4 = { class: "send-test-email-dialog__title" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-close",
    "aria-hidden": "true"
}, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "send-test-email-dialog__field" };
const _hoisted_9 = { class: "send-test-email-dialog__label" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1));
const _hoisted_11 = { class: "send-test-email-dialog__hint" };
const _hoisted_12 = { class: "send-test-email-dialog__actions" };
import { computed, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { sendCampaignEmailTest } from '@/features/CampaignsEmail/services/sendCampaignEmailTest';
import { useSendTestEmailDialog } from '@/features/CampaignsEmail/composables/useSendTestEmailDialog';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SendTestEmailDialog',
    props: {
        modelValue: { type: Boolean },
        campaignTitle: {},
        template: {},
        preheader: { default: '' },
        senderEmail: { default: '' },
        senderName: { default: '' },
        replyToEmail: { default: '' }
    },
    emits: ["update:modelValue", "sent"],
    setup(__props, { emit }) {
        const props = __props;
        const { t } = useI18n();
        const modelValueRef = toRef(props, 'modelValue');
        const campaignTitleRef = toRef(props, 'campaignTitle');
        const templateRef = toRef(props, 'template');
        const preheaderRef = toRef(props, 'preheader');
        const senderEmailRef = toRef(props, 'senderEmail');
        const senderNameRef = toRef(props, 'senderName');
        const replyToEmailRef = toRef(props, 'replyToEmail');
        const modelValueProxy = computed({
            get: () => modelValueRef.value,
            set: (v) => emit('update:modelValue', v),
        });
        const { isOpen, destEmailsText, destEmailsInputRef, sending, hasInvalidEmails, isShowingTooltip, tooltipText, normalizeDestEmails, handleDestEmailsPaste, handleDestEmailsBlur, handleDestEmailsKeydown, handleSend, } = useSendTestEmailDialog({
            modelValue: modelValueProxy,
            campaignTitle: campaignTitleRef,
            template: templateRef,
            preheader: preheaderRef,
            senderEmail: senderEmailRef,
            senderName: senderNameRef,
            replyToEmail: replyToEmailRef,
            sendFn: sendCampaignEmailTest,
            onSent: () => emit('sent'),
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: _unref(isOpen),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(isOpen) ? (isOpen).value = $event : null)),
                class: "send-test-email-dialog",
                width: "453px",
                "append-to-body": "",
                "show-close": false
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test-dialog.title')), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "send-test-email-dialog__close",
                                    disabled: _unref(sending),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = false)),
                                    "aria-label": "Close"
                                }, _hoisted_7, 8, _hoisted_5)
                            ]),
                            _createElementVNode("label", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test-dialog.dest-email-label')) + " ", 1),
                                    _hoisted_10
                                ]),
                                _withDirectives(_createVNode(_component_el_input, {
                                    ref_key: "destEmailsInputRef",
                                    ref: destEmailsInputRef,
                                    modelValue: _unref(destEmailsText),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(destEmailsText) ? (destEmailsText).value = $event : null)),
                                    type: "textarea",
                                    resize: "none",
                                    autosize: { minRows: 1, maxRows: 3 },
                                    placeholder: _unref(t)('breadcrumb.email.campaign.send-email-test-dialog.dest-email-placeholder'),
                                    class: _normalizeClass({ 'is-error': _unref(hasInvalidEmails) }),
                                    onInput: _unref(normalizeDestEmails),
                                    onPaste: _unref(handleDestEmailsPaste),
                                    onKeydown: _unref(handleDestEmailsKeydown),
                                    onBlur: _unref(handleDestEmailsBlur)
                                }, null, 8, ["modelValue", "placeholder", "class", "onInput", "onPaste", "onKeydown", "onBlur"]), [
                                    [
                                        _directive_tooltip,
                                        {
                                            theme: 'error',
                                            autoHide: false,
                                            distance: 8,
                                            content: _unref(tooltipText),
                                            shown: _unref(isShowingTooltip),
                                            popperClass: 'send-test-email-dialog__error-tooltip',
                                        },
                                        void 0,
                                        { right: true }
                                    ]
                                ]),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test-dialog.dest-email-help')), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_button, {
                                class: "send-test-email-dialog__btn send-test-email-dialog__btn--cancel",
                                disabled: _unref(sending),
                                onClick: _cache[2] || (_cache[2] = ($event) => (isOpen.value = false))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test-dialog.cancel')), 1)
                                ]),
                                _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_el_button, {
                                class: "send-test-email-dialog__btn send-test-email-dialog__btn--send",
                                type: "primary",
                                loading: _unref(sending),
                                onClick: _unref(handleSend)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('breadcrumb.email.campaign.send-email-test-dialog.send')), 1)
                                ]),
                                _: 1
                            }, 8, ["loading", "onClick"])
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
